import * as React from "react"
import {optHtmlContent, renderDynamicContent} from "../../Utilities/CmsUtilities";
import {SimOnlyPlan} from "../../Model/Sales/SimOnlyPlan";
import {SALES_PORTAL_ROUTES} from "../../Routes/SalesPortalRoutes";
import {ApplicationContext} from "../../ApplicationContext";
import {CmsContent} from "../../Model/CmsContent/CmsContent";
import HeaderFooterWrapper from "../../Components/Navigation/HeaderFooterWrapper";
import {CmsCDN} from "../../Model/CmsContent/CmsCDN";
import {Navigate} from "react-router-dom";
import {LatestBlogPostPane} from "../BlogListPage/BlogListPage";
import PlanCarousel from "../../Components/Superdrug/PlanCarousel";
import {CarouselContentType} from "../../Model/Sales/CarouselContentType";

interface SuperdrugSplashPageProps {

    /**
     * Array of all content currently stored in the CMS that has been made available to the Sales Portal.
     */
    readonly cmsContent: CmsContent[]

    /**
     * Array of the best SIM-only plans provided by the reseller to be
     * displayed on the splash screen.
     */
    readonly simOnlyPlans: SimOnlyPlan[]

}

/**
 * Function will render the splash page for Superdrug.
 */
const SuperdrugSplashPage = (props: SuperdrugSplashPageProps): JSX.Element => {

    const applicationContext = React.useContext(ApplicationContext)

    React.useEffect(() => {

    }, [])

    React.useEffect(() => {
        // Trustpilot script is maintained by morons so we need to re-apply it here.
        const optTrustpilotCdn = props.cmsContent.find((content) =>
            content.reference === "trustpilot-cdn")
        if (optTrustpilotCdn && optTrustpilotCdn.jsonContent) {
            const cdnSource = optTrustpilotCdn.jsonContent as CmsCDN
            const script = document.createElement("script")
            script.src = cdnSource.href
            document.head.appendChild(script)
        }
    }, [])

    const optHomePage = optHtmlContent(props.cmsContent, "sp-page-home")
    const optPageHomeBanner = optHtmlContent(props.cmsContent, "sp-page-home-banner")

    if (!optHomePage) {
        return <Navigate to={SALES_PORTAL_ROUTES.InternalError(applicationContext.urlContext)}/>
    } else {
        return (
            <HeaderFooterWrapper cmsContent={props.cmsContent}>
                {renderDynamicContent(optHomePage, [
                    {key: "BLOG_LATEST", value: <LatestBlogPostPane cmsContent={props.cmsContent} />},
                    {key: "DYNAMIC_SIM_ONLY_PLANS_CAROUSEL", value: <PlanCarousel
                            availableSimOnlyPlans={props.simOnlyPlans}
                            carouselContentType={CarouselContentType.STANDARD}
                        />},
                    {key: "BANNER", value: renderDynamicContent(optPageHomeBanner || "", [])
                    }
                ])}
            </HeaderFooterWrapper>
        )
    }

}

export default SuperdrugSplashPage